import { BaseService } from './base-service';
import { GetCompanyOptionsParamsDTO } from '@/core/dto/company';
import { GetCompaniesRequestDTO, GetCompaniesResponseDTO } from '@/core/dto/company/get-companies';
import { Company } from '@/types/entities/Company';
import { GetCompaniesMapper } from '@/core/mapper/company';
import { SelectOption } from '@/components/ui/SelectOptions/types';

export class CompanyService extends BaseService<Company> {
	private static instance: CompanyService;

	private constructor(public readonly basePath: string = '/company') {
		super();
	}

	public static getInstance(): CompanyService {
		if (!CompanyService.instance) {
			CompanyService.instance = new CompanyService();
		}
		return CompanyService.instance;
	}

	public async listOptions(params: GetCompanyOptionsParamsDTO): Promise<Company[]> {
		const url = this.basePath + `/list`;
		const { data } = await this.getInstance().get(url, { params });
		return data;
	}

	public async getCompanies(params: GetCompaniesRequestDTO): Promise<SelectOption[]> {
		const url = this.basePath + `/user_list/${params.organization_id}`;
		const { data } = await this.getInstance().get<GetCompaniesResponseDTO>(url);
		return new GetCompaniesMapper(data).toDomain();
	}
}
